import { Select } from "antd";
import { FC } from "react";

const SelectVoteStatusField: FC<any> = (props: any) => {
  return (
    <Select {...props}>
      <Select.Option key="skiped" >skiped</Select.Option>
      <Select.Option key="new" >new</Select.Option>
      <Select.Option key="voted" >voted</Select.Option>
      <Select.Option key="disliked" >disliked</Select.Option>
    </Select>
  )
}

export default SelectVoteStatusField
